import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useRequestMatterAccess = () => {
  const { getFetchConfig } = useGetFetchConfig();

  const requestAccess = async (matterId: string) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
    });

    const response = await fetch(`${APIBaseChronos}/api/matters/${matterId}/request-access`, fetchConfig);
    if (!response.ok) {
      throw new Error('Error requesting access to matter');
    }
    return response.json();
  };

  return useMutation({
    mutationFn: requestAccess,
    onSuccess: () => {
      toast.success('Access request sent to the matter owner');
    },
    onError: (error) => {
      console.error('Error requesting matter access:', error);
      toast.error('Failed to request access. Please try again.');
    },
  });
};
